/**
 * Created by user on 2019/3/8.
 */

import OPDSV1 from './lib/v1';

export { OPDSV1 }

export default OPDSV1;
